const BULB_COUNT = 24;
const RADIUS = 311;
const PALETTE = ['#DCC149', '#353CEE', '#FFB800', '#1E2288', '#FEFCE3', '#353CEE'];

const rand = (a, b) => Math.random() * (b - a) + a;

const darken = (hex, pct = 12) => {
    const n = parseInt(hex.slice(1), 16);
    let r = (n >> 16) & 255;
    let g = (n >> 8) & 255;
    let b = n & 255;

    r = Math.max(0, Math.floor((r * (100 - pct)) / 100));
    g = Math.max(0, Math.floor((g * (100 - pct)) / 100));
    b = Math.max(0, Math.floor((b * (100 - pct)) / 100));

    return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
};

export const createBulbs = () =>
    Array.from({ length: BULB_COUNT }, (_, i) => {
        const angleDeg = (i * 360) / BULB_COUNT;
        const color = PALETTE[Math.floor(Math.random() * PALETTE.length)];

        return {
            key: `bulb-${i}`,
            angleDeg,
            color,
            size: 26,
            duration: +rand(1.1, 2.2).toFixed(2),
            delay: +rand(0, 1.0).toFixed(2)
        };
    });

export const getBulbStyle = (b) => {
    const rad = (b.angleDeg * Math.PI) / 180;
    let x = RADIUS * Math.cos(rad);
    let y = RADIUS * Math.sin(rad);

    const darker = darken(b.color, 18);
    const isGold = ['#DCC149', '#FFB800', '#FEFCE3'].includes(b.color);
    const glowColor = isGold ? '#DCC149' : '#353CEE';

    return {
        width: b.size + 'px',
        height: b.size + 'px',
        left: `calc(50% + ${x - b.size / 2}px)`,
        top: `calc(50% + ${y - b.size / 2}px)`,
        backgroundImage: `radial-gradient(circle at 50% 45%, #ffffff 0%, ${b.color} 46%, ${darker} 82%)`,
        boxShadow: `
          0 0 0 1.5px ${glowColor}44,
          0 0 8px ${glowColor}AA,
          0 0 18px ${glowColor}66,
          0 0 34px ${glowColor}40,
          inset 0 0 10px rgba(0,0,0,.08)
        `,
        borderRadius: '9999px',
        animation: `bulbGlow ${b.duration}s ${b.delay}s ease-in-out infinite`
    };
};
